export default {

    init() {
        this.notificationsActionsToggle();
    },

    notificationsActionsToggle() {
        let moreActionsBtn = $('.notifications-section .actions-more');

        moreActionsBtn.on('click', function (e) {
            e.preventDefault();

            let thisDrop = $(this).parent().find('.actions-drop');
            let drops = $('.notifications-section .actions-drop');
            drops.removeClass('current');
            thisDrop.addClass('current');

            let dropdowns = $('.actions-drop:not(.current)');
            dropdowns.removeClass('active');

            thisDrop.toggleClass('active');
        });

        let dropdowns = $('.notifications-section .actions-drop');

        $('body').on('click', function (e) {
            if (!moreActionsBtn.is(e.target) && moreActionsBtn.has(e.target).length === 0 && !dropdowns.is(e.target) && dropdowns.has(e.target).length === 0) {
                dropdowns.removeClass('active');
            }
        });
    },
}